<template>
  <div>
    <div v-if="item" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="item.name"
        :headline="item.name"
        :link="[
          { text: 'Danh sách lớp bán trú', href: '../boarding-class' },
          { text: item.name, id: item.id },
        ]"
      />
      <v-card class="d-flex justify-space-between align-center my-4 pa-5 border" outlined>
        <v-row no-gutters>
          <v-col cols="3" md="2">
            <span> Lớp bán trú </span>
            <h4>{{ item.name || '' }}</h4>
          </v-col>
          <v-col cols="2" md="2">
            <div>Sĩ số học sinh</div>
            <div class="font-weight-bold">{{ item.studentCount }} / 50</div>
          </v-col>
          <v-col cols="2" md="2">
            <div>Số lượng giáo viên</div>
            <div class="font-weight-bold">{{ item.teacherCount }} / 10</div>
          </v-col>
          <v-col cols="2" md="2">
            <div>Trạng thái</div>
            <v-chip small class="white--text" v-if="item.status" :color="item.status | boardingClassStatusColor" label>
              {{ item.status | boardingClassStatus }}
            </v-chip>
          </v-col>
          <v-col cols="3" md="4" class="detail d-flex justify-end align-center">
            <v-btn class="search-button ml-6" @click="() => $refs['popup-detail'].openDialog()" outlined>
              Hồ sơ chi tiết
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <DetailTabs class="mt-8" />
      <PopupDetail ref="popup-detail" @edit="() => $refs['popup-update'].openDialog(item)" />
      <PopupUpdate ref="popup-update" />
    </div>
    <h1 v-else-if="!$loading.active">DayBoarding not found</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import PopupUpdate from './PopupUpdate.vue'
import PopupDetail from './PopupDetail.vue'
import DetailTabs from './DetailTabs.vue'

export default {
  components: {
    Breadcrumbs,
    PopupUpdate,
    PopupDetail,
    DetailTabs,
  },
  computed: {
    ...mapGetters('boardingClass', ['item']),
  },
  methods: {
    ...mapActions('boardingClass', ['fetchOne']),
  },
  async created() {
    this.$loading.active = true
    await this.fetchOne(this.$route.params.id)
    this.$loading.active = false
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
